import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SortService {
  reA = /[^a-zA-Z]/g;
  reN = /[^0-9]/g;

  constructor(
    private translateService: TranslateService
  ) { }

  public sort(data: any, property: string, direction: boolean) {
    if (property === 'turbineCodeMonitor') {
      property = 'turbineCode';
      return this.sortAlphanumeric(data, property, direction);
    } else {
      return this.sortAll(data, property, direction);
    }
  }

  private getNestedObject = (properties, obj) => properties.reduce((xs, x) => (xs && xs[x] !== null) ? xs[x] : null, obj);

 

  /**
   * data: Array elements
   * property: Field to sort
   * direction: True(Asc), False(Desc), Undefined (No direction)
   * Null/Undefined values are always on the bottom of the list. Not sorted
   */
  private sortAll(data: any, property: string, direction: boolean) {
    const propertiesSplice = property.split('.');
    const propertiesCounter = propertiesSplice.length > 1 ? [...propertiesSplice] : [property];
    const myCollator = new Intl.Collator();
    const sortedArray = data.sort((obj1: any, obj2: any) => {
      let result;
      const value1 = this.getNestedObject([...propertiesCounter], obj1);
      const value2 = this.getNestedObject([...propertiesCounter], obj2);
      if (value1 === value2) {
          return 0;
      } else if (value1 === null || value1 === undefined) {
          return 1;
      } else if (value2 === null || value2 === undefined) {
          return -1;
      } else if (isNaN(value1) && isNaN(value2)) {
          result = myCollator.compare(value1, value2);
      } else {
          result = value1 > value2 ? 1 : -1; // value1 - value2;
      }
      if (direction) {
        return result * -1;
      } else {
        return result;
      }
    });
    return sortedArray;
  }

  private sortAlphanumeric(data: any, property: string, direction: boolean) {
    const propertiesSplice = property.split('.');
    const propertiesCounter = propertiesSplice.length > 1 ? [...propertiesSplice] : [property];
    const sortedArray = data.sort((obj1: any, obj2: any) => {
      let result;
      const value1A = this.getNestedObject([...propertiesCounter], obj1).replace(/_/gi, '').replace(this.reA, '');
      const value2A = this.getNestedObject([...propertiesCounter], obj2).replace(/_/gi, '').replace(this.reA, '');
      if (value1A === value2A) {
        const value1N = parseInt(this.getNestedObject([...propertiesCounter], obj1).replace(this.reN, ''), 10);
        const value2N = parseInt(this.getNestedObject([...propertiesCounter], obj2).replace(this.reN, ''), 10);
        result = value1N === value2N ? 0 : value1N > value2N ? 1 : -1;
      } else {
        result = value1A > value2A ? 1 : -1;
      }
      if (direction) {
         return result * -1;
      } else {
        return result;
      }
    });
    return sortedArray;
  }

  public sortByDisplayNameAZ = (a: any, b: any): number => {
    return a.displayName.localeCompare(b.displayName, this.translateService.currentLang, { numeric: true });
  }

  public sortByDisplayNameZA = (a: any, b: any): number => {
    return b.displayName.localeCompare(a.displayName, this.translateService.currentLang, { numeric: true });
  }


}
